import { render, staticRenderFns } from "./NICrRecovery.vue?vue&type=template&id=58be7c4a&"
import script from "./NICrRecovery.vue?vue&type=script&lang=js&"
export * from "./NICrRecovery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports